import type { SVGProps } from 'react';

const SvgQuietHours = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="quiet-hours">
      <path d="m14.78 26.7 8.53 5a.86.86 0 0 0 .38.1.8.8 0 0 0 .37-.1.74.74 0 0 0 .38-.65V26.7h4a2.74 2.74 0 0 0 2.71-2.7V3A2.74 2.74 0 0 0 28.42.21H3.58A2.74 2.74 0 0 0 .85 3v21a2.74 2.74 0 0 0 2.73 2.7ZM2.35 24V3a1.24 1.24 0 0 1 1.23-1.29h24.84A1.24 1.24 0 0 1 29.65 3v21a1.23 1.23 0 0 1-1.23 1.23h-4.73a.76.76 0 0 0-.75.75v3.78l-7.57-4.46a.86.86 0 0 0-.38-.1H3.58A1.23 1.23 0 0 1 2.35 24" />
      <path d="M15.79 22.59a9.34 9.34 0 0 0 9-7 .74.74 0 0 0-.29-.8.77.77 0 0 0-.87 0 6.67 6.67 0 0 1-3.93 1.26 6.77 6.77 0 0 1-5.49-10.68.75.75 0 0 0-.81-1.16 9.35 9.35 0 0 0 2.39 18.38M12 6.4a8.2 8.2 0 0 0-.53 2.91 8.31 8.31 0 0 0 11.2 7.76A7.84 7.84 0 1 1 12 6.4" />
      <path d="M17.42 12.35h5.16v-1.5h-3.35l3.39-3.38a.78.78 0 0 0 .16-.82.75.75 0 0 0-.69-.46h-4.8v1.5h3l-3.38 3.38a.75.75 0 0 0 .53 1.28Z" />
    </g>
  </svg>
);

export default SvgQuietHours;
